/* eslint-disable no-unused-vars */
import React from 'react'
import {Link, StaticQuery} from 'gatsby'
import Logo from '../assets/albert_logo_white.svg'
import ArrowDown from '../assets/arrow_down.svg'
import LoginUserIcon from '../assets/login.svg'
import Button from './Button'
import DropDown from './DropDown'
import { menuItems, metaTags } from '../utils/content'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet';
import { logEvent } from './Analytics';
import Seo from './Seo';

const Header = ({ color, replace = false, device, headerMobileActive,  dispatchHeaderMenu, query, title, referUserId}) => {

	const closeHeader = () => {
        dispatchHeaderMenu(false)
        document.getElementsByTagName('body')[0].className = '';
	}
	
	let defaultButtons = (
		<React.Fragment>
			<DropDown 
				leftIcon={<LoginUserIcon />}
				rightIcon={<ArrowDown/>}
				text="Logga in"
				textColor="#fff"
				menuItems={menuItems}
				onMouseEneter={ dispatchHeaderMenu }
                readHeader={headerMobileActive}
			/>

			<Button 
				title='Bjud ditt barn på läxhjälp' 
				id='newAccountButton' 
				style={{borderRadius: '50px', color: color}} 
				handleClick={() => {
						document.getElementById('accountForm').scrollIntoView({behavior: 'smooth', block: 'center'});
						logEvent(
							`Header Bjud ditt barn på läxhjälp button`,
							`Header Bjud ditt barn på läxhjälp button was clicked`
						);
					}
				}
			/>
		</React.Fragment>
	)
	
	const customTag = (id) => {
		let meta = [{
				name: "description",
				content: "Albert är Barnens Digitala Mattelärare. Med tusentals övningar och animerade videos hjälper han dig att förstå matematiken du behöver kunna för just din årskurs.",
			},
			{
				name: "keywords",
				content: "Albert, Math, Mattelärare, Digitala Mattelärare, matematiken",
			},
		];
		if(id){
			meta = [{
					name: "og:title",
					content: "Varsågod, jag bjuder på gratis läxhjälp!"
				},
				{
					name: "fb:app_id",
					content: "271034299921078"
				},
				
				{
					name: "og:description",
					content: "Jag bjuder härmed in dig att prova på Albert - Barnens digitala mattelärare, gratis tillsvidare! Klicka på länken för att ta emot gåvan."
				},
				{
					name: "og:image",
					content: `https://hejalbert.se${query.desktop_banner_photo.publicURL}`
				},
				{
					name: "og:url",
					content: `https://hejalbert.se/invite/${id}`
				}
			]
		}
		return meta;
	}
	return (
		<header id="header" onMouseLeave={closeHeader}>
			<Helmet
				title={title}
				meta={customTag(referUserId)}
				link={[
					{ rel: "icon", type: "image/png", sizes: "16x16", href: `${query.favicon.publicURL}` },
				]}
			/>
			<Seo/>
			<Link to="/">
				<Logo style={{fill: color}} />
			</Link>
			<div id="headerAccount">
				{replace ? replace : defaultButtons}
			</div>
		</header>
	)
}
const reduxRegisterState = (state) => {
    return {
        headerMobileActive: state.headerMobileActive,
    }
}
  
const reduxRegisterStateDispatch = dispatch => {
    return { 
        dispatchHeaderMenu: (plan) => dispatch({ type: `HEADER_MOBILE_MENU`, value: plan }),
    }
}

const Head = connect(reduxRegisterState, reduxRegisterStateDispatch)(Header);

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    favicon: file(relativePath: {regex: "/faviicon/"}) {
                        publicURL
					}   
					desktop_banner_photo: file(relativePath: {regex: "/desktop-banner-img/"}) 
					{
						publicURL
					}	                 
                }`
            }
        render={(data)  => (
           <Head query={data} {...props}/>
        )}
    />
)